module.exports = "/_next/static/files/7edeedd0df828aeb166f8305104622b2.png";